import { Link } from "react-router-dom";
import { LogOut, ShieldCheck, Users, Building2, Cpu, LayoutDashboard, HelpCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV_ITEMS = [
  { to: "/dashboard", label: "Tableau de bord", icon: LayoutDashboard, roles: null },
  { to: "/admin/utilisateurs", label: "Utilisateurs", icon: Users, roles: ["Administrateur national", "Administrateur Site"] },
  { to: "/admin/sites", label: "Sites", icon: Building2, roles: ["Administrateur national"] },
  { to: "/admin/google-diagnostic", label: "Diagnostic Google", icon: Cpu, roles: ["Administrateur national"] },
  { to: "/aide", label: "Aide", icon: HelpCircle, roles: null },
];

export default function AppHeader() {
  const { user, logout } = useAuth();

  return (
    <header className="border-b border-border/60 backdrop-blur-md bg-card/40 sticky top-0 z-20">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between gap-6">
        <Link to="/dashboard" className="flex items-center gap-3 shrink-0">
          <div className="h-8 w-8 rounded-sm bg-primary/15 border border-primary/40 flex items-center justify-center">
            <ShieldCheck className="h-4 w-4 text-primary" />
          </div>
          <span className="font-heading font-black uppercase tracking-wide text-base leading-none">HFACS</span>
        </Link>

        <nav className="flex items-center gap-1 flex-1 overflow-x-auto">
          {NAV_ITEMS.filter((item) => !item.roles || item.roles.includes(user?.role)).map((item) => (
            <Link
              key={item.to}
              to={item.to}
              data-testid={`nav-link-${item.to.replace(/\//g, "-")}`}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-sm text-xs font-mono uppercase tracking-wider text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors whitespace-nowrap"
            >
              <item.icon className="h-3.5 w-3.5" />
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3 shrink-0">
          <div className="text-right hidden sm:block">
            <p data-testid="header-user-name" className="text-sm font-medium leading-tight">
              {user?.prenom ? `${user.prenom} ${user.nom}` : user?.name}
            </p>
            <p data-testid="header-user-role" className="text-[10px] font-mono uppercase text-primary tracking-wide">
              {user?.role}
            </p>
          </div>
          <button
            onClick={logout}
            data-testid="logout-button"
            className="p-2 rounded-sm border border-border text-muted-foreground hover:text-rose-600 hover:border-rose-500/40 transition-colors"
            title="Se déconnecter"
          >
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </div>
    </header>
  );
}
